var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {},
    [
      _vm._t("header"),
      !_vm.isEmptyListPlaceholderShown
        ? _c(
            "div",
            [
              _c(
                "LoadingOverlay",
                {
                  attrs: {
                    hasData: !!_vm.documents,
                    loading: _vm.$apollo.loading,
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _vm._t("default", function () {
                        return [
                          _c("DocumentTable", {
                            attrs: {
                              classCarePlan: _vm.classCarePlan,
                              documents: _vm.documents,
                              currentUser: _vm.currentUser,
                              isProject: _vm.isProject,
                              isCustomHeight: _vm.isCustomHeight,
                              customRequestId: _vm.customRequestId,
                            },
                            on: { documentDeleted: _vm.updateDocumentList },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        : _c(
            "EmptyListPlaceholderSidebar",
            {
              attrs: {
                title: _vm.emptyListTitle,
                subtitle: _vm.emptyListSubtitle,
              },
            },
            [
              _vm.allowUploads
                ? _vm._t("emptyListActions", null, {
                    refetchDocuments: _vm.updateDocumentList,
                  })
                : _vm._e(),
            ],
            2
          ),
      _vm.allowUploads
        ? _vm._t("actions", null, { refetchDocuments: _vm.updateDocumentList })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }